<template>

<div>

<h2 class="goth">Perfekt med sein som hjälpverb</h2>
<div class="grammatikparagrafbredd leftorient">

<h4>Perfekt kan böjas med hjälpverbet sein</h4>

<p>I tyskan bildas perfekt hos många verb med hjälpverbet <i>sein</i>
    (böjt som <b><i>bin, bist, ist, sind</i></b> eller <i><b>seid</b></i>) istället för med någon form av <i>haben</i>.</p>
<br>

<div class="ruta">
<p><i><b>Sind</b> sie schon gekommen?</i></p>
<p><i><b>Har</b> de redan kommit?</i></p>
<br>
<p><i>Erich <b>ist</b> nach Stockholm gefahren.</i></p>
<p><i>Erich <b>har</b> åkt till Stockholm.</i></p>
<br>
<p><i>Du <b>bist</b> in Berlin gewesen.</i></p>
<p><i>Du <b>har</b> varit i Berlin.</i></p>

</div>
<br>
<p>Verb som använder någon form av <i>sein</i> istället för <i>haben</i> som hjälpverb är i huvudsak dessa kategorier:</p>

<ul>
<li>Förflyttningsverb</li>
<li>Tillståndsförändrande verb</li>
<li>Specialverben <i>bleiben, sein, werden</i></li>
</ul>
<br>
<h4>Förflyttningsverb</h4>

<p>Så kallade <i>förflyttningsverb</i> som t.ex. <i>fahren, gehen, laufen, fliegen</i> använder <i>sein</i> som hjälpverb i perfekt.</p>

<br>

<div class="ruta">
<p><i>Sie <b>sind</b> gestern gefahren.</i></p>
<p><i>De <b>har</b> åkt igår.</i></p>
<br>
<p><i>Wir <b>sind</b> zur Schule gegangen.</i></p>
<p><i>Vi <b>har</b> gått till skolan.</i></p>
<br>
<p><i><b>Bist</b> du schnell gelaufen?</i></p>
<p><i><b>Har</b> du sprungit snabbt?</i></p>
<br>
<p><i>Neil Armstrong und Buzz Aldrin <b>sind</b> zum Mond geflogen.</i></p>
<p><i>Neil Armstrong och Buzz Aldrin <b>har</b> flugit till månen.</i></p>

</div>
<br>

<p class="minitext">Ibland kallas dessa <i>intransitiva</i> rörelseverb.
    Intransitiv innebär att inget ackusativ finns knutet till verbet.
    <i>Transitiva verb</i> (verb som har ett ackusativ knutet till sig) böjs nämligen alltid med <i>haben</i> i perfekt. </p>

<div class="ruta">
<p class="minitext"><u>intransitivt</u><br><i>Erich <b>ist</b> nach Südamerika geflogen.</i></p><br>
<p class="minitext"><i>Erich <b>har</b> flugit till Südamerika.</i></p><br>
<p class="minitext"><u>transitivt</u><br><i>Der Pilot <b>hat</b> das Flugzeug geflogen</i></p><br>
<p class="minitext"><i>Piloten <b>har</b> flugit flygplanet.</i></p>
</div>


<h4>Tillståndsförändrande verb</h4>



<p>Verb som uttrycker förändring av tillstånd böjs med <i>sein</i> som hjälperb i perfekt. t.ex.
<i>sterben, aufwachen, einschlafen, schmelzen</i></p>

<br>

<div class="ruta">
<p><i>Opa <b>ist</b> gestorben.</i></p>
<p><i>Morfar <b>har</b> dött.</i></p>
<br>
<p><i><b>Bist</b> du eingeschlafen?</i></p>
<p><i><b>Har</b> du somnat.</i></p>
<br>
<p><i>Er <b>ist</b> aufgewacht.</i></p>
<p><i>Han <b>har</b> vaknat.</i></p>
<br>
<p><i>Das Eis <b>ist</b> geschmolzen.</i></p>
<p><i>Isen <b>har</b> smält.</i></p>
</div>
<br>


<p class="minitext">Precis som med rörelseverben böjs dessa endast med sein om de är <i>intransitiva</i>.</p>

<br>
<div class="ruta">
<p class="minitext"><u>intransitivt</u><br><i>Das Eis <b>ist</b> geschmolzen.</i></p><br>
<p class="minitext"><i>Isen <b>har</b> smält.</i></p><br>
<p class="minitext"><u>transitivt</u><br><i>Der Schmied <b>hat</b> das Metal geschmolzen.</i></p><br>
<p class="minitext"><i>Smeden <b>har</b> smält metallen.</i></p>

</div>
<br>
<h4>geblieben, gewesen, geworden</h4>

<p>Odern <i>bleiben = stanna, sein = vara, werden = bli </i> böjs alltid med sein som
    hjälpverb i perfekt. Deras respektive perfektparticipformer är
    <i><b>geblieben</b> (stannat), <b>gewesen</b> (varit) och <b>geworden</b> (blivit)</i>.</p>

    <br>

    <div class="ruta">
    <p><i>Ich <b>bin</b> in Malmö gewesen.</i></p>
    <p><i>Jag <b>har</b> varit i Malmö.</i></p>
    <br>
    <p><i>Wir <b>sind</b> da lange geblieben.</i></p>
    <p><i>Vi <b>har</b> varit där länge.</i></p>
    <br>
    <p><i>Aber dann <b>ist</b> es langweilig geworden.</i></p>
    <p><i>Men sen blev det (<b>har</b> det blivit) tråkigt.</i></p>
</div>
    <br>




</div>

<div class="grammatikparagrafbredd leftorient">
<h4>Exempel på verb som böjs med sein</h4>

<table class="">

    <tr class="leftorient">
        <th class="ljusgra">
        <th  class="ljusgra">infinitiv</th>
        <th class="ljusgra">perfekt</th>
    </tr>

    <tr class="leftorient">
        <td class="ljusgra">stanna</td>
        <td class="ljusgra"><i>bleib</i>|<i>en</i></td>
        <td class="ljusgra"><i><div class="minitext">er ist </div><b> ge</b>blieb<b>en</b></i></td>
    </tr>

    <tr class="leftorient">
        <td class="ljusgra">åka, fara</td>
        <td class="ljusgra"><i>fahr</i>|<i>en</i></td>
        <td class="ljusgra"><i><div class="minitext">er ist </div><b> ge</b>fahr<b>en</b></i></td>
    </tr>

    <tr class="leftorient">
        <td class="ljusgra">flyga</td>
        <td class="ljusgra"><i>flieg</i>|<i>en</i></td>
        <td class="ljusgra"><i><div class="minitext">er ist </div><b> ge</b>flog<b>en</b></i></td>
    </tr>

    <tr class="leftorient">
        <td class="ljusgra">gå</td>
        <td class="ljusgra"><i>geh</i>|<i>en</i></td>
        <td class="ljusgra"><i><div class="minitext">er ist </div><b> ge</b>gang<b>en</b></i></td>
    </tr>

    <tr class="leftorient">
        <td class="ljusgra">komma</td>
        <td class="ljusgra"><i>komm</i>|<i>en</i></td>
        <td class="ljusgra"><i><div class="minitext">er ist </div><b> ge</b>komm<b>en</b></i></td>
    </tr>


    <tr class="leftorient">
        <td class="ljusgra">springa, löpa</td>
        <td class="ljusgra"><i>lauf</i>|<i>en</i></td>
        <td class="ljusgra"><i><div class="minitext">er ist </div><b> ge</b>lauf<b>en</b></i></td>
    </tr>

    <tr class="leftorient">
        <td class="ljusgra">resa</td>
        <td class="ljusgra"><i>reis</i>|<i>en</i></td>
        <td class="ljusgra"><i><div class="minitext">er ist </div><b> ge</b>reis<b>t</b></i></td>
    </tr>

    <tr class="leftorient">
        <td class="ljusgra">springa</td>
        <td class="ljusgra"><i>renn</i>|<i>en</i></td>
        <td class="ljusgra"><i><div class="minitext">er ist </div><b> ge</b>rann<b>t</b></i></td>
    </tr>

    <tr class="leftorient">
        <td class="ljusgra">smälta</td>
        <td class="ljusgra"><i>schmelz</i>|<i>en</i></td>
        <td class="ljusgra"><i><div class="minitext">er ist </div><b> ge</b>schmolz<b>en</b></i></td>
    </tr>

    <tr class="leftorient">
        <td class="ljusgra">vara</td>
        <td class="ljusgra"><i>sein</i></td>
        <td class="ljusgra"><i><div class="minitext">er ist </div><b> gewesen</b></i></td>
    </tr>

    <tr class="leftorient">
        <td class="ljusgra">hoppa</td>
        <td class="ljusgra"><i>spring</i>|<i>en</i></td>
        <td class="ljusgra"><i><div class="minitext">er ist </div><b> ge</b>sprung<b>en</b></i></td>
    </tr>

    <tr class="leftorient">
        <td class="ljusgra">dö</td>
        <td class="ljusgra"><i>sterb</i>|<i>en</i></td>
        <td class="ljusgra"><i><div class="minitext">er ist </div><b> ge</b>storb<b>en</b></i></td>
    </tr>

    <tr class="leftorient">
        <td class="ljusgra">bli</td>
        <td class="ljusgra"><i>werd</i>|<i>en</i></td>
        <td class="ljusgra"><i><div class="minitext">er ist </div> <b> ge</b>word<b>en</b></i></td>
    </tr>


</table>


<p>De flesta (men inte alla) verb som böjs med sein i perfekt är dessutom <i>starka
    verb</i>, d.v.s. perfektparticipformen fås genom ge- + [perfektstamm] + –en.</p>

</div>
</div>


</template>

<script>
export default {
  name: 'Grammatik',
  props: {
    msg: String
},
metaInfo() {
    return {
        meta: [
            {
                vmid: "description",
                name: "description",
                content: "perfekt med sein som hjälpverb"
            }
        ]
    }
},


}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>



</style>
